"use client";

import { c as _c } from "react/compiler-runtime";
import { CatalogCardDefinition, CatalogCardFrame, CatalogItemHeading, CatalogTileProps, PriceFooter, TypeCorner } from "../components/catalog-card-primitives";
import React from "react";
import { FiRepeat } from "react-icons/fi";
import { cx } from "@/lib/tailwind-utils";
const MembershipMotif: React.FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><div className="absolute -right-20 top-8 h-56 w-56 rounded-full border border-primary/10" /><div className="absolute bottom-10 right-8 h-16 w-28 rounded-full border border-primary/15" /><div className="absolute bottom-14 right-14 h-8 w-8 rounded-full border border-primary/20" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const membershipCard: CatalogCardDefinition = {
  label: "Membership",
  Icon: FiRepeat,
  visual: {
    background: "bg-[radial-gradient(circle_at_78%_8%,rgb(var(--primary)_/_0.14),transparent_58%)] bg-background",
    Motif: MembershipMotif
  },
  eyebrow: item => item.category ?? "Membership"
};
export const MembershipTile: React.FC<CatalogTileProps> = t0 => {
  const $ = _c(23);
  const {
    item,
    onSelect,
    compact: t1,
    className,
    opensDialog,
    placement
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const select = item.alreadyMember ? undefined : onSelect;
  const t2 = item.alreadyMember && "opacity-60 grayscale";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cx("h-auto max-h-none sm:h-auto sm:max-h-none", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== compact) {
    t4 = <TypeCorner definition={membershipCard} compact={compact} />;
    $[3] = compact;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== item) {
    t5 = <CatalogItemHeading item={item} definition={membershipCard} showFullDescription={true} />;
    $[5] = item;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = Boolean(select);
  const t7 = item.alreadyMember ? "Already enrolled" : undefined;
  let t8;
  if ($[7] !== item || $[8] !== t6 || $[9] !== t7) {
    t8 = <PriceFooter item={item} interactive={t6} statusLabel={t7} />;
    $[7] = item;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5 || $[12] !== t8) {
    t9 = <div className="relative flex h-full flex-1 flex-col">{t5}{t8}</div>;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== compact || $[15] !== item || $[16] !== opensDialog || $[17] !== placement || $[18] !== select || $[19] !== t3 || $[20] !== t4 || $[21] !== t9) {
    t10 = <CatalogCardFrame item={item} onSelect={select} compact={compact} className={t3} opensDialog={opensDialog} placement={placement} definition={membershipCard} corner={t4}>{t9}</CatalogCardFrame>;
    $[14] = compact;
    $[15] = item;
    $[16] = opensDialog;
    $[17] = placement;
    $[18] = select;
    $[19] = t3;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};